import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';


const INITIAL_STATE_VEHICLES_HISTORY_COLOR = {
  'colorsHistory': [],
  'activeColors': [],
  'loading': false,
  'updating': false,
  'initialState': {
    'colorType': '',
    'inDoorColor': '',
    'inDoorColorDescription': '',
    'outDoorColor': '',
    'outDoorColorDescription': '',
    'status': 'A',
    'price': 0,
  },
};

export const vehicleHistoryColors = (state, action) => {
  return createReducer(INITIAL_STATE_VEHICLES_HISTORY_COLOR, {
    [ActionTypes.FETCHING_VEHICLES_HISTORY_COLORS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLES_HISTORY_COLORS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'colorsHistory': [],
    }),
    [ActionTypes.FETCHED_VEHICLES_HISTORY_COLORS]: (state, action) => ({
      ...state,
      'loading': false,
      'colorsHistory': action.response.data,
    }),
    [ActionTypes.FETCHING_ACTIVE_COLORS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ACTIVE_COLORS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'activeColors': [],
    }),
    [ActionTypes.FETCHED_ACTIVE_COLORS]: (state, action) => ({
      ...state,
      'loading': false,
      'activeColors': action.response.data,
    }),
    [ActionTypes.UPDATING_VEHICLES_HISTORY_COLORS]: (state, action) => ({
      ...state,
      'updating': true,
    }),
    [ActionTypes.UPDATED_VEHICLES_HISTORY_COLORS]: (state, action) => ({
      ...state,
      'updating': false,
    }),
    [ActionTypes.UPDATED_VEHICLES_HISTORY_COLORS_FAILED]: (state, action) => ({
      ...state,
      'updating': false,
    }),
    [ActionTypes.CREATING_VEHICLES_HISTORY_COLORS]: (state, action) => ({
      ...state,
      'updating': true,
    }),
    [ActionTypes.CREATED_VEHICLES_HISTORY_COLORS]: (state, action) => ({
      ...state,
      'updating': false,
    }),
    [ActionTypes.CREATED_VEHICLES_HISTORY_COLORS_FAILED]: (state, action) => ({
      ...state,
      'updating': false,
    }),
    [ActionTypes.CHANGE_VEHICLES_HISTORY_COLOR_STATE]: (state, action) => ({
      ...state,
      'initialState': {
        ...state.initialState,
        [action.payload.key]: action.payload.value,
      },
    }),
  })(state, action);
};
